import React, { useEffect, useMemo, useState } from "react";
import { Button } from "antd";

const resolveSelectedLabelKey = (colorOptions, selectedBox) => {
  if (!Array.isArray(colorOptions) || !colorOptions.length) return null;
  if (!selectedBox) return null;

  const optionMatch = colorOptions.find((opt) => opt.value === selectedBox.customLabel)
    || colorOptions.find((opt) => opt.color === selectedBox.customColor);

  return optionMatch?.key ?? colorOptions[0].key;
};

const AnnotateBoxActionsPanel = ({
  title,
  colorOptions,
  isEditMode,
  selectedBox,
  selectedId,
  readOnly = false,
  onAddBox,
  onSelectLabel,
}) => {
  const canAdd = useMemo(() => Array.isArray(colorOptions) && colorOptions.length > 0, [colorOptions]);
  const [selectedLabelKey, setSelectedLabelKey] = useState(() => resolveSelectedLabelKey(colorOptions, selectedBox));

  useEffect(() => {
    if (!canAdd) {
      setSelectedLabelKey(null);
      return;
    }

    setSelectedLabelKey(resolveSelectedLabelKey(colorOptions, selectedBox));
  }, [canAdd, colorOptions, selectedBox]);

  const handleAddClick = () => {
    if (readOnly) return;
    if (!canAdd) return;
    if (typeof onAddBox === "function") onAddBox();
  };

  const handleOptionClick = (key) => {
    if (readOnly) return;
    setSelectedLabelKey(key);
    if (typeof onSelectLabel === "function") onSelectLabel(key);
  };

  return (
    <div className="AnnotateImageModal__ActionContainer">
      <div className="AnnotateImageModal__ActionTitleRow">
        {title && <div className="AnnotateImageModal__ActionTitle">{title}</div>}
        <Button
          type="primary"
          size="small"
          className="AnnotateImageModal__AddBoxBtn"
          disabled={readOnly || !canAdd || !!selectedId}
          onClick={handleAddClick}
        >
          Add
        </Button>
      </div>

      {(!selectedBox && !isEditMode && !readOnly) && (
        <div className="AnnotateImageModal__ColorOptionList AnnotateImageModal__ColorOptionList--compact AnnotateImageModal__ColorOptionList--placeholder">
          <div className="AnnotateImageModal__MetaText AnnotateImageModal__MetaText--center">
            <p>Select a box to change its type</p>
          </div>
        </div>
      )}

      {(selectedBox && isEditMode && !readOnly) && (
        <div className="AnnotateImageModal__ColorOptionList AnnotateImageModal__ColorOptionList--compact">
          <div className="AnnotateImageModal__MetaText">
            <p>Choose box type from the options below</p>
          </div>
          {colorOptions.map((option) => (
            <button
              key={option.key}
              type="button"
              className={`AnnotateImageModal__ColorOption ${selectedLabelKey === option.key ? "AnnotateImageModal__ColorOption--selected" : ""}`}
              onClick={() => handleOptionClick(option.key)}
            >
              <span className="AnnotateImageModal__ColorDot" style={{ backgroundColor: option.color }} />
              <span className="AnnotateImageModal__ColorText">{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnnotateBoxActionsPanel;
